import { Component, computed, inject, input, OnInit, output, signal } from '@angular/core';
import { DsButtonModule, DsFormFieldModule, DsModalModule, DsToggleButtonModule } from '@bmw-ds/components';
import { TranslateModule } from '@ngx-translate/core';
import { BackofficeStore } from 'src/app/core/stores/backoffice.store';
import { ActionPlan } from 'src/app/shared/models/backoffice/action-plan.model';

@Component({
  selector: 'pure-comfy-action-plan-modal',
  imports: [TranslateModule, DsFormFieldModule, DsModalModule, DsButtonModule, DsToggleButtonModule],
  templateUrl: './comfy-action-plan-modal.html',
  styleUrl: './comfy-action-plan-modal.scss',
})
export class ComfyActionPlanModalComponent implements OnInit {
  vin = input<string>();
  closed = output<void>();

  private readonly backofficeStore = inject(BackofficeStore);

  modalIsOpen = signal<boolean>(true);
  actionPlanChanged = signal<boolean>(false);

  readonly actionPlanOptions = computed(() => this.backofficeStore.actionPlan() || []);

  ngOnInit(): void {
    const vin = this.vin();
    if (vin) {
      this.backofficeStore.loadActionPlan(vin);
    }
  }

  modalDismissed(): void {
    this.modalIsOpen.set(false);
  }

  protected isActionPlanVisible(actionPlan: ActionPlan): boolean {
    return actionPlan.isActive;
  }

  protected onActionPlan(actionPlan: ActionPlan): void {
    actionPlan.isActive = !actionPlan.isActive;
    this.actionPlanChanged.set(true);
  }

  protected onSave(): void {
    const vin = this.vin();
    if (vin) {
      this.backofficeStore.updateActionPlan(vin, this.actionPlanOptions());
      this.modalDismissed();
    }
  }
}
